import {TweenLite} from 'gsap'
const ScrollToPlugin = require('gsap/ScrollToPlugin')

const NAVIGATION     = '.js-navigation',
      NAV_TRIGGER    = '.js-nav-trigger',
      NAV_WRAPPER    = 'js-nav-wrapper',
      CLASS_ACTIVE   = '-active',
      SCROLL_TRIGGER = '.js-scrollto',
      DATE_TARGET    = 'data-target'

  /**
   * @export
   * @class Navigation
   */
  export default class Navigation {

    constructor() {
      this.isSP          = false
      this.breakPoint    = 834
      this.nav           = document.querySelectorAll(NAVIGATION)
      this.trigger       = document.querySelectorAll(NAV_TRIGGER)
      this.scrollTrigger = document.querySelectorAll(SCROLL_TRIGGER)
      this.navWrapper    = document.getElementById(NAV_WRAPPER)
      this.init()
    }

    init() {
      this.handler()
    }

    handler(el) {
      Array.prototype.forEach.call(this.trigger, (el) => {
        el.addEventListener('click', (el) => {
          this.toggleActive()
        })
      })

      Array.prototype.forEach.call(this.scrollTrigger, (el) => {
        el.addEventListener('click', (el) => {
          window.innerWidth < this.breakPoint ? this.isSP = true : this.isSP = false
          this.scroll(el)
          if (this.isSP) this.toggleActive()
        })
      })
    }

    toggleActive() {
      for (let i = 0; i < this.trigger.length; i++) {
        this.trigger[i].classList.toggle(CLASS_ACTIVE)
      }
      for (let i = 0; i < this.nav.length; i++) {
        this.nav[i].classList.toggle(CLASS_ACTIVE)
      }
    }

    scroll(el) {
      el.preventDefault()
      window.innerWidth < this.breakPoint ? this.isSP = true : this.isSP = false
      const dataTarget = el.currentTarget.getAttribute(DATE_TARGET)
      const targetElm = document.getElementById(dataTarget)
      const scrollPosition = this.navWrapper.clientHeight
      TweenLite.to(window, .5, {scrollTo:{y:targetElm, offsetY:scrollPosition, autoKill:false}})
    }
  }